import { FC } from 'react'

import { ResourceHeader } from '@factorialco/factorial-one-react/dist/experimental'
import { TrainingRequestDetailFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { getStatusLabel, getStatusVariant } from 'modules/trainings/lib/utils'

type Props = {
  trainingRequest: TrainingRequestDetailFragment
}

const RequestHeader: FC<Props> = ({ trainingRequest }) => {
  const approverList =
    trainingRequest.status !== 'draft'
      ? trainingRequest.currentApprovers.map((approver) => ({
          id: approver.id,
          firstName: approver.firstName,
          lastName: approver.lastName,
          type: 'person' as const,
          avatar: buildUrl(approver.avatar),
        }))
      : []
  return (
    <ResourceHeader
      metadata={[
        trainingRequest.status === 'review' && {
          label: i18n.t('trainings.training_requests.header.approver'),
          value: {
            type: 'list',
            variant: 'person',
            avatars: approverList,
          },
        },
      ]}
      status={{
        label: '',
        text: getStatusLabel(trainingRequest.status),
        variant: getStatusVariant(trainingRequest.status),
      }}
      title={trainingRequest.trainingName ?? ''}
    />
  )
}

export default RequestHeader
